// 全站同一個時間元件（SPEC #vms-web-973「多語與時間格式」、UX-12 / UX-17；VMS UX 評審 2026-10-13 P1-12）：
//   清單用相對時間（「3 分鐘前」）、滑過看完整時間；完整時間一律 `2026-10-13 22:34`（24 小時制，lib/timefmt.ts）。
import { useTranslation } from 'react-i18next';
import { relative, stamp } from '../lib/timefmt';

export function Time({
  at,
  tz,
  rel,
  seconds,
  empty = '—',
}: {
  /** ISO 字串或毫秒 */
  at: string | number | null | undefined;
  /** 完整時間用的時區（沒給 = 瀏覽器時區） */
  tz?: string;
  /** 相對時間（清單用），滑過看完整時間 */
  rel?: boolean;
  seconds?: boolean;
  empty?: string;
}) {
  const { t } = useTranslation();
  const ms = typeof at === 'number' ? at : at ? Date.parse(at) : NaN;
  if (!Number.isFinite(ms) || ms <= 0) return <>{empty}</>;
  const full = stamp(ms, { tz, seconds });
  return (
    <time dateTime={new Date(ms).toISOString()} title={rel ? full : undefined}>
      {rel ? relative(t, ms) : full}
    </time>
  );
}
